import { baseApi } from '@/config/axios';
import {
  CreateCoatingParams,
  CreateCoatingResponse,
  FetchCoatingCourseInfosParams,
  FetchCoatingCourseInfosResponse,
  FetchCoatingUnitsResponse,
  PaidyConfirmCoatingParams,
  PaidyConfirmCoatingResponse,
  PrepareCoatingPaymentParams,
  PrepareCoatingPaymentResponse,
} from '@/types/api/coatingApi';

/** コーティングメニュー情報取得 */
export const fetchCoatingCourseInfos = (
  params: FetchCoatingCourseInfosParams,
): Promise<FetchCoatingCourseInfosResponse> =>
  baseApi.get('v1/customer/coating/course-infos', { params });

/** コーティング決済準備（t_payment_managements 作成） */
export const prepareCoatingPayment = (
  params: PrepareCoatingPaymentParams,
): Promise<PrepareCoatingPaymentResponse> =>
  baseApi.post('v1/customer/coating/prepare-payment', params);

/** コーティング Paidy 決済確定（capture → t_payment_managements 支払済保存） */
export const paidyConfirmCoating = (
  params: PaidyConfirmCoatingParams,
): Promise<PaidyConfirmCoatingResponse> =>
  baseApi.post('v1/customer/coating/paidy-confirm', params);

/** コーティング対応店舗一覧取得 */
export const fetchCoatingUnits = (): Promise<FetchCoatingUnitsResponse> =>
  baseApi.get('v1/customer/coating/units');

/** コーティング予約作成（決済完了後） */
export const createCoating = (
  params: CreateCoatingParams,
): Promise<CreateCoatingResponse> =>
  baseApi.post('v1/customer/coating/create', params);
